import { Tabs } from '@cian/ui-kit';
import { SyntheticEvent, FC, ReactNode, useCallback, useState } from 'react';
import { SelectOption } from './components';
import { ISelectOption, TSelectValue } from 'shared/types/filters';
import { FDealType, FOfferType, normalizeOfferType } from '../../../../../packages/JsonQuery';
import { OFFER_TYPE_OPTIONS } from './constants';

import styles from './DropdownOfferType.css';

interface IDropdownOfferType {
  dealType: FDealType;
  offerType: FOfferType;
  options: ISelectOption[];
  value: TSelectValue;
  disabled?: boolean;
  postfix?: ReactNode;
  onChange(value: TSelectValue, e: SyntheticEvent): void;
  onOfferTypeChange(value: FOfferType): void;
}

export const DropdownOfferType: FC<IDropdownOfferType> = ({
  dealType,
  offerType,
  options,
  value,
  postfix,
  onChange,
  onOfferTypeChange,
}) => {
  const index = OFFER_TYPE_OPTIONS.findIndex(option => option.value === normalizeOfferType(offerType));

  const [activeTabIndex, setActiveTabIndex] = useState(index);

  const handleOptionClick = useCallback(
    (option: ISelectOption, event: SyntheticEvent<HTMLDivElement>) => {
      let newValue: TSelectValue;

      if (Array.isArray(value)) {
        newValue = value.includes(option.value)
          ? value.filter(optionValue => optionValue !== option.value)
          : [...value, option.value];
      } else {
        newValue = [option.value];
      }

      onChange(newValue, event);
    },
    [onChange, value],
  );

  const handleTabClick = (index: number): void => {
    setActiveTabIndex(index);

    const newOfferType: FOfferType = OFFER_TYPE_OPTIONS[index].value;

    if (normalizeOfferType(offerType) !== normalizeOfferType(newOfferType)) {
      const nextOfferType = newOfferType === FOfferType.Residential ? FOfferType.Flat : FOfferType.Office;

      onOfferTypeChange(nextOfferType);
    }
  };

  return (
    <div data-testid="DropdownSelect">
      {dealType !== FDealType.RentDaily && (
        <div className={styles['tabs']}>
          <Tabs onTabClick={handleTabClick} activeTabIndex={activeTabIndex} items={OFFER_TYPE_OPTIONS} size="S" />
        </div>
      )}

      {options.map((option, index) => (
        <SelectOption
          {...option}
          key={option.value}
          index={index}
          selected={Array.isArray(value) ? value.includes(option.value) : value === option.value}
          onClick={event => handleOptionClick(option, event)}
        />
      ))}
      {postfix}
    </div>
  );
};
